import { SETTINGS_TRUE_VALUE } from '@spike/marketplace-model';
import { OLB_WAITLIST_ENABLED_KEY, saveOlbWaitlistEnabledThunk } from 'actions/waitlists/WaitlistsActions';
import { useApiClientWrapper } from 'hooks';
import { FunctionComponent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import RowSwitch from './RowSwitch';

interface JoinWaitlistSettingProps {
    isMobile?: boolean;
    disabled?: boolean;
    className?: string;
}

export const JoinWaitlistSetting: FunctionComponent<JoinWaitlistSettingProps> = props => {
    const dispatch = useDispatch();
    const apiClientWrapper = useApiClientWrapper();

    const settings = useSelector((state: RootState) => state.marketplace.marketplace.settings);
    const savedEnabled =
        settings.find(setting => setting.key === OLB_WAITLIST_ENABLED_KEY)?.value === SETTINGS_TRUE_VALUE;

    const [enabled, setEnabled] = useState(savedEnabled);

    const changeHandler = async (checked: boolean) => {
        setEnabled(checked);

        const saved = await (dispatch(
            saveOlbWaitlistEnabledThunk(apiClientWrapper, checked)
        ) as unknown as Promise<boolean>);

        if (!saved) {
            setEnabled(!checked);
        }
    };

    return (
        <RowSwitch
            label="Allow clients to join waitlist"
            checked={enabled}
            name="olbWaitlistEnabled"
            errors={[]}
            isMobile={props.isMobile}
            disabled={props.disabled}
            onChange={changeHandler}
            className={props.className}
        />
    );
};

export default JoinWaitlistSetting;
